export const firebaseConfig = {
    apiKey: "AIzaSyDYybCZHfmSp3baiD2Q4Nj7umnjXv0V4as",
    authDomain: "belyfted-custom.firebaseapp.com",
    projectId: "belyfted-custom",
    storageBucket: "belyfted-custom.firebasestorage.app",
    messagingSenderId: "967439359060",
    appId: "1:967439359060:web:d0cc0c7af6b8a9958c21c1",
    measurementId: "G-264SJVX882"
};

export const vapidKey =
    "BF2t4JBkV8vNI8T9Je17cafqyAK76iFXeDnB9K-2BnUJ3h5Lgo302mYspEuTD4N2Z9jwMdgzjMUQjFfXuccOO2k"; // from Firebase → Project Settings → Cloud Messaging → Web Push certificates
